import { InputMask } from '@react-input/mask';
import { DatePicker, TimePickerProps } from 'antd';
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import Select, { GroupBase, MenuListProps, StylesConfig, components } from "react-select";
import { JSX } from 'react/jsx-runtime';
import DateField from '../../../../core/common/textFields/DateField';
import TextField from '../../../../core/common/textFields/TextField';
import { useCreateContactMutation, useLazyGetContactByIdQuery } from '../../../../services/EndPointsApis';
import { svgIcons } from '../../../../style/fonts/SvgIcons';
import ContactsSidebar from '../../Contacts/ContactsSidebar';
import { Dayjs } from "dayjs";



const GeneralTab = ({ formik, triggerExistingLeadData, getExtLeadsById, disabledata, initialValues, getdefaultLookups, getLeadsByID, trigger, refetchContactsLookup, getExistingLeadsLookups, getContactsLookup }: any) => {
    dayjs.extend(customParseFormat);
    const onChangeStart: TimePickerProps['onChange'] = (time, timeString) => {
    };
    const location = useLocation();
    const isReadOnly = location.pathname.includes('viewLead');
    const isEdit = location.pathname.includes('editLead');
    const [selectedProspectDate, setSelectedProspectDate] = useState<Date | null>(null);
    const [selectedConsultationDate, setSelectedConsultationDate] = useState<Date | null>(null);
    const navigate = useNavigate()
    const [updateId, setUpdateId] = useState(0);
    const [contactsidebarOpen, setContactsidebarOpen] = useState(false);
    const [contactId, setContactId] = useState(0)

    //to get contacts data by id to populate
    const [triggerContacts, { data: getaccountByID }] = useLazyGetContactByIdQuery();
    //Add contacts APi for props to sidebar contacts
    const [createContact, { data, isError, error, isSuccess, isLoading }] =
        useCreateContactMutation();

    const params = useParams()
    const prospectId = params?.id
    const customStyles: StylesConfig = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
            color: state.isFocused ? "#fff" : "#000",
            "&:hover": {
                backgroundColor: "rgba(177, 31, 40, 1)",
            },
        }),
    };
    const closeSidebar = () => {
        setContactsidebarOpen(false);
    };
    const SelectMenuButtonContacts = (props: JSX.IntrinsicAttributes & MenuListProps<unknown, boolean, GroupBase<unknown>>) => {
        return (
            <components.MenuList {...props}>
                <div style={{ padding: '10px', textAlign: 'center' }}>
                    <button
                        className='btn btn-transparent p-0'
                        type='button'
                        style={{ width: '100%' }}
                        onClick={(e) => {
                            e.stopPropagation();
                            setContactsidebarOpen(true)
                        }}
                    >
                        + Add New Contact
                    </button>
                </div>
                {props.children}

            </components.MenuList>
        );
    };

    const options = getContactsLookup?.result?.map((option: any) => ({
        label: option?.value,
        value: option?.id,
    })) || [];

    const CustomSingleValue = () => {
        return (
            <Link className='position-absolute' to={`/leadsProspect/editLead/${formik?.values?.lst_Leads?.id}`}>
                {
                    formik?.values?.lst_Leads?.value ?
                        <span className='bg-aliceblue d-flex gap-1 align-items-center'>{svgIcons?.LeadIconBlue}{formik?.values?.lst_Leads?.value}</span>
                        : ''

                }
            </Link>
        );
    };



    // const handleChange = (newValue: InfluencerOption[]) => {
    //     const ids = newValue.map(option => option?.value);
    //     const titles = newValue.map(option => option?.label);

    //     formik.setFieldValue('lst_Influencer.id', ids);
    //     formik.setFieldValue('lst_Influencer.name', titles);

    //     setSelectedItems(newValue.map(option => ({
    //         id: option.value, // Assuming value is the ID
    //         title: option.label // Assuming label is the title
    //     })));
    // };



    useEffect(() => {
        if (getLeadsByID?.result) {
            setSelectedConsultationDate(getLeadsByID?.result?.consultationDate)
            setSelectedProspectDate(getLeadsByID?.result?.prospectDate)
        }
    }, [getLeadsByID]);

    useEffect(() => {
        if (isEdit || isReadOnly) {
            trigger({ prospectId: prospectId || formik.values.currentStep })
        }
    }, [isEdit, isReadOnly, params])

    // useEffect(() => {
    //     matchLabels();
    //     if (isReadOnly === true || isEdit === true) {
    //         trigger({ prospectId: prospectId })
    //     }

    // }, [selectedItems, selectedNestedItems]);


    const handleProspectDateChange = (date: Dayjs | null) => {
        // setSelectedFreshAptDate(date);
        formik.setFieldValue('prospectDate', date ? date.format('YYYY-MM-DD') : null);
    };

    const handleConsultationDateChange = (date: Dayjs | null) => {
        // setSelectedFreshAptDate(date);
        formik.setFieldValue('consultationDate', date ? date.format('YYYY-MM-DD') : null);
    };



    useEffect(() => {
        if (isSuccess) {
            refetchContactsLookup()
        }
    }, [isSuccess]);

    // for selection on existing lead data 

    useEffect(() => {
        if (getExtLeadsById?.result && Object.keys(getExtLeadsById?.result).length > 0) {
            setUpdateId(getExtLeadsById?.result?.leadProspectId);
            formik.setValues({ ...formik.values, ...getExtLeadsById.result });
            // setDisabledata(true)
        } else {
            setUpdateId(0);
        }
    }, [getExtLeadsById]);

    // for selectiong no to existing lead if already data populated

    // useEffect(() => {
    //     if (formik.values?.lst_ExistingLead?.id === 2) {
    //         if (getExtLeadsById?.result && Object.keys(getExtLeadsById?.result).length > 0) {
    //             setUpdateId(getExtLeadsById?.result?.leadProspectId);
    //             formik.resetForm({
    //                 values: { ...getExtLeadsById?.result },
    //             });
    //         } else {
    //             setUpdateId(0)
    //         }
    //     }
    // }, [getExtLeadsById, updateId, formik.values?.lst_ExistingLead?.id]);

    // for all lead data 
    useEffect(() => {
        if (getLeadsByID?.result && Object.keys(getLeadsByID?.result).length > 0) {
            setUpdateId(getLeadsByID?.result?.leadProspectId);
            formik.setValues({ ...getLeadsByID?.result });
        } else {
            setUpdateId(0);
        }
    }, [getLeadsByID]);

    const selectValues = formik.values?.lst_Influencer
        ? formik.values.lst_Influencer
            .filter((influencer: { id: number; value: string }) => influencer.id !== 0 && influencer.value !== '')
            .map((influencer: { id: number; value: string }) => ({
                value: influencer.id,
                label: influencer.value,
            }))
        : [];



    const handleExistingContactsChange = (selectedOption: any) => {
        formik.setFieldValue('lst_Contact.id', selectedOption.value);
        formik.setFieldValue('lst_Contact.value', selectedOption.label);
        setContactId(selectedOption.value)
        triggerContacts({ contactId: selectedOption.value })
    };
    useEffect(() => {
        if (getaccountByID?.result) {
            // Set form values with the fetched data
            formik.setFieldValue('firstName', getaccountByID.result.firstName);
            formik.setFieldValue('lastName', getaccountByID.result.lastName);
            formik.setFieldValue('mainPhone', getaccountByID.result.workPhone);
            formik.setFieldValue('mobilePhone', getaccountByID.result.cellPhone);
            formik.setFieldValue('emailAddress', getaccountByID.result.email);
            formik.setFieldValue('addressLine1', getaccountByID.result.addressLine1);
            formik.setFieldValue('addressLine2', getaccountByID.result.addressLine2);
            formik.setFieldValue('addressCity', getaccountByID.result.city);
            formik.setFieldValue('addressStateOrProvince', getaccountByID.result.state);
            formik.setFieldValue('addressPostalCode', getaccountByID.result.zipCode);
        }
    }, [getaccountByID]);

    const EmptyGuid = '00000000-0000-0000-0000-000000000000';
    const DefaultGuid = '3fa85f64-5717-4562-b3fc-2c963f66afa6';
    return (
        <>

            <ContactsSidebar activityTogglePopup={contactsidebarOpen} closeSidebar={closeSidebar} refetchContactsLookup={refetchContactsLookup} createContact={createContact} error={error} isError={isError} data={data} isSuccess={isSuccess} />
            <div className="row mt-2" style={{ height: '539px', overflow: 'auto' }}>
                <div className="col-md-4">
                    <div className="card">

                        <div className="card-body card-css">
                            <h5 className='mb-2'>
                                Contact Information
                            </h5>
                            <div className="col-md-12">
                                <label className='input-label'>Choose Existing Contact</label>
                                <Select
                                    styles={customStyles}
                                    className="select"
                                    options={options}
                                    value={
                                        formik.values?.lst_Contact?.id
                                            ? {
                                                value: formik.values?.lst_Contact?.id,
                                                label: formik.values?.lst_Contact?.value || '',
                                            }
                                            : null
                                    }
                                    isDisabled={isReadOnly || disabledata}
                                    // onChange={(selectedOption: any) => {
                                    //     formik.setFieldValue('lst_Contact.id', selectedOption.value);
                                    //     formik.setFieldValue('existingContacts.value', selectedOption.label);
                                    // }}
                                    onChange={(selectedOption: any) =>
                                        handleExistingContactsChange(selectedOption)

                                    }
                                    components={{ MenuList: SelectMenuButtonContacts }}
                                />
                            </div>
                            {/* <div className="col-md-12">
                                <label className='input-label'>Prefix</label>
                                <Select
                                    styles={customStyles}
                                    className="select"
                                    options={getdefaultLookups?.result?.Lst_Prefix?.map((option: any) => ({
                                        label: option?.value,
                                        value: option?.id
                                    }))}
                                    value={
                                        formik.values?.lst_Prefix?.id
                                            ? {
                                                value: formik.values?.lst_Prefix?.id,
                                                label: formik.values?.lst_Prefix?.value || '',
                                            }
                                            : null
                                    }
                                    isDisabled={isReadOnly || disabledata}
                                    onChange={(selectedOption: any) => {
                                        formik.setFieldValue('lst_Prefix.id', selectedOption.value);
                                        formik.setFieldValue('lst_Prefix.value', selectedOption.label);
                                    }}
                                />
                            </div> */}
                            <div className="col-md-12">
                                <TextField
                                    label="First Name "
                                    type="text"
                                    {...formik.getFieldProps("firstName")}
                                    disabled={isReadOnly || disabledata}

                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="Last Name"
                                    type="text"
                                    {...formik.getFieldProps("lastName")}
                                    disabled={isReadOnly || disabledata}


                                />
                            </div>
                            <div className="col-md-12">
                                <label className='input-label'>Main Phone </label>
                                <InputMask mask="(___) ___-____"
                                    replacement={{ _: /\d/ }}
                                    placeholder="(847) 763-1100"
                                    className="form-control"
                                    {...formik.getFieldProps("mainPhone")}
                                    disabled={isReadOnly || disabledata}

                                />
                            </div>
                            <div className="col-md-12">
                                <label className='input-label'>Main Phone Type</label>
                                <Select
                                    styles={customStyles}
                                    className="select"
                                    options={getdefaultLookups?.result?.Lst_MainPhoneType
                                        ?.map((option: any) => ({
                                            label: option?.value,
                                            value: option?.id
                                        }))}
                                    value={
                                        formik.values?.lst_MainPhoneType?.id
                                            ? {
                                                value: formik.values?.lst_MainPhoneType?.id,
                                                label: formik.values?.lst_MainPhoneType?.value || '',
                                            }
                                            : null
                                    }
                                    isDisabled={isReadOnly || disabledata}

                                    onChange={(selectedOption: any) => {
                                        formik.setFieldValue('lst_MainPhoneType.id', selectedOption.value);
                                        formik.setFieldValue('lst_MainPhoneType.value', selectedOption.label);
                                    }}
                                />
                            </div>
                            <div className="col-md-12">
                                <label className='input-label'>Mobile Phone</label>
                                <InputMask mask="(___) ___-____"
                                    replacement={{ _: /\d/ }}
                                    placeholder="(847) 763-1100"
                                    className="form-control"
                                    {...formik.getFieldProps("mobilePhone")}
                                    disabled={isReadOnly || disabledata}

                                />
                            </div>
                            {/* <div className="col-md-12">
                                <TextField
                                    label="CTM Caller ID"
                                    type="text"
                                    {...formik.getFieldProps("ctmCallerID")}
                                    disabled={isReadOnly || disabledata}

                                />
                            </div> */}
                            <div className="col-md-12">
                                <TextField
                                    label="E-Mail Address"
                                    type="email"
                                    {...formik.getFieldProps("emailAddress")}
                                    disabled={isReadOnly || disabledata}


                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="Contact Preferences"
                                    type="text"
                                    {...formik.getFieldProps("contactPreferences")}
                                    disabled={isReadOnly || disabledata}


                                />
                            </div>
                        </div>
                    </div>
                    <div className='card'>
                        <div className='card-body card-css'>
                            <h5>
                                Home Address
                            </h5>
                            <div className="col-md-12">
                                <TextField
                                    label="Address Composite"
                                    type="text"
                                    {...formik.getFieldProps("addressComposite")}
                                    disabled={isReadOnly || disabledata}
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="Address Line 1"
                                    type="text"
                                    {...formik.getFieldProps("addressLine1")}
                                    disabled={isReadOnly || disabledata}

                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="Address Line 2"
                                    type="text"
                                    {...formik.getFieldProps("addressLine2")}
                                    disabled={isReadOnly || disabledata}
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="City"
                                    type="text"
                                    {...formik.getFieldProps("addressCity")}
                                    disabled={isReadOnly || disabledata}
                                // icon={svgIcons.LockIcon}
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="State or Province"
                                    type="text"
                                    {...formik.getFieldProps("addressStateOrProvince")}
                                    disabled={isReadOnly || disabledata}

                                // icon={svgIcons.LockIcon}

                                />
                            </div>
                            <div className="col-md-12">
                                <label>Postal Code (Pick Below)</label>
                                <InputMask mask="_____-____"
                                    replacement={{ _: /\d/ }}
                                    className="form-control"
                                    {...formik.getFieldProps("addressPostalCode")}
                                    disabled={isReadOnly || disabledata}
                                />
                            </div>
                            {/* <div className="col-md-12">
                                    <TextField
                                        label="Postal Code \"
                                        type="text"
                                        {...formik.getFieldProps("postalCodeLookup")}
                                        disabled={isReadOnly || disabledata}
                                    />
                                </div> */}
                            <div className="col-md-12">
                                <TextField
                                    label="Zillow Estimate"
                                    type="text"
                                    {...formik.getFieldProps("zillowEstimate")}
                                    disabled={isReadOnly || disabledata}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="card">
                        <div className="card-body card-css p-3">
                            <h5 className='mb-2'>Identify Contact</h5>
                            <div className="col-md-12">
                                <TextField
                                    label="Name"
                                    type="text"
                                    {...formik.getFieldProps("name")}
                                    disabled={isReadOnly}
                                    required
                                />
                                {formik.touched.name && formik.errors.name && (
                                    <div className="error">{formik.errors.name}</div>
                                )}
                            </div>
                            {formik.values?.lst_ExistingLead?.id === 1 ?
                                <div className="col-md-12">
                                    <label className='input-label'> Lead Prospect <span className='text-danger'>*</span></label>
                                    <Select
                                        styles={customStyles}
                                        className="select custom"
                                        options={getExistingLeadsLookups?.result?.map((option: any) => ({
                                            label: option?.value,
                                            value: option?.id
                                        }))}
                                        value={
                                            formik.values?.lst_Leads?.id
                                                ? {
                                                    value: formik.values?.lst_Leads?.id,
                                                    label: formik.values?.lst_Leads?.value || '',
                                                }
                                                : null
                                        }
                                        isDisabled={isReadOnly || getLeadsByID && formik.values.currentStep >= 3}
                                        onChange={(selectedOption: any) => {
                                            triggerExistingLeadData({ Id: selectedOption.value })
                                            setTimeout(() => {
                                                formik.setFieldValue('lst_Leads.id', selectedOption.value);
                                                formik.setFieldValue('lst_Leads.value', selectedOption.label);
                                            }, 2000);
                                        }}
                                        components={{ SingleValue: CustomSingleValue }}
                                    />
                                    {formik.touched.lst_Leads && formik.errors.lst_Leads && (
                                        <div className="error">{formik.errors.lst_Leads.value}</div>
                                    )}
                                </div> : ''

                            }
                            <div className="col-md-12">
                                <label className='input-label'>Existing Lead </label>
                                <Select
                                    styles={customStyles}
                                    className="select"
                                    options={getdefaultLookups?.result?.Lst_ExistingLeads
                                        ?.map((option: any) => ({
                                            label: option?.value,
                                            value: option?.id
                                        }))}
                                    value={
                                        formik.values?.lst_ExistingLead?.id
                                            ? {
                                                value: formik.values?.lst_ExistingLead?.id,
                                                label: formik.values?.lst_ExistingLead?.value || '',
                                            }
                                            : null
                                    }
                                    isDisabled={isReadOnly || formik.values?.lst_Leads?.id !== EmptyGuid}
                                    onChange={(selectedOption: any) => {
                                        formik.setFieldValue('lst_ExistingLead.id', selectedOption.value);
                                        formik.setFieldValue('lst_ExistingLead.value', selectedOption.label);
                                        if (selectedOption.value === 2) {
                                            triggerExistingLeadData({ Id: '00000000-0000-0000-0000-000000000000' })
                                        }

                                    }}
                                />
                            </div>
                            <>
                                <label className='input-label d-flex align-items-center gap-1'> {svgIcons.LockIcon}Account </label>
                                <div className='col-md-12 br-gray p-2 bg-gray'>
                                    {/* { getLeadsByID && formik.values.currentStep >= 3  ?
                                        <Link to={`/accounts/EditAccounts/${formik.values.lst_Account.id}`}>
                                            <span className='me-1'> {svgIcons?.AccountIconBlue}</span>
                                            {formik?.values?.lst_Account?.value}
                                        </Link>
                                        : !isEdit && !isReadOnly && getExtLeadsById ? <Link to={`/accounts/EditAccounts/${formik.values.lst_Account.id}`}>
                                            <span className='me-1'> {svgIcons?.AccountIconBlue}</span>
                                            {formik?.values?.lst_Account?.value}
                                        </Link> : ''} */}
                                    {
                                        formik?.values?.lst_Account?.id !== EmptyGuid ? (
                                            getLeadsByID ? (
                                                <Link to={`/accounts/EditAccounts/${formik.values.lst_Account?.id}`}>
                                                    <span className="me-1">{svgIcons?.AccountIconBlue}</span>
                                                    {formik?.values?.lst_Account?.value}
                                                </Link>
                                            ) : (
                                                !isEdit && !isReadOnly && getExtLeadsById && (
                                                    <Link to={`/accounts/EditAccounts/${formik.values.lst_Account?.id}`}>
                                                        <span className="me-1">{svgIcons?.AccountIconBlue}</span>
                                                        {formik?.values?.lst_Account?.value}
                                                    </Link>
                                                )
                                            )
                                        ) : (
                                            ''
                                        )
                                    }

                                </div>
                            </>
                            <div className="col-md-12">
                                <label className='input-label'>Verified Contact </label>
                                <Select
                                    styles={customStyles}
                                    className="select"
                                    options={getdefaultLookups?.result?.
                                        Lst_VerifiedContact?.map((option: any) => ({
                                            label: option?.value,
                                            value: option?.id
                                        }))}
                                    value={
                                        formik.values?.lst_VerifiedContact?.id
                                            ? {
                                                value: formik.values?.lst_VerifiedContact?.id,
                                                label: formik.values?.lst_VerifiedContact?.value || '',
                                            }
                                            : null
                                    }
                                    isDisabled={isReadOnly}
                                    onChange={(selectedOption: any) => {
                                        formik.setFieldValue('lst_VerifiedContact.id', selectedOption.value);
                                        formik.setFieldValue('lst_VerifiedContact.value', selectedOption.label);
                                    }}
                                />
                            </div>
                            <>
                                <label className='input-label d-flex align-items-center gap-1'> {svgIcons.LockIcon}Contact </label>
                                <div className='col-md-12 br-gray p-2 bg-gray'>
                                    {
                                        formik?.values?.lst_Contact?.id !== EmptyGuid ? (
                                            getLeadsByID ? (
                                                <Link to={`/contacts/EditContacts/${formik.values.lst_Contact?.id}`}>
                                                    <span className="me-1">{svgIcons?.ContactIconBlue}</span>
                                                    {formik?.values?.lst_Contact?.value}
                                                </Link>
                                            ) : (
                                                !isEdit && !isReadOnly && getExtLeadsById && (
                                                    <Link to={`/contacts/EditContacts/${formik.values.lst_Contact?.id}`}>
                                                        <span className="me-1">{svgIcons?.ContactIconBlue}</span>
                                                        {formik?.values?.lst_Contact?.value}
                                                    </Link>
                                                )
                                            )
                                        ) : (
                                            ''
                                        )
                                    }

                                </div>

                            </>
                            <div className="col-md-12">
                                <label className='input-label'>Verified Prospect </label>
                                <Select
                                    styles={customStyles}
                                    className="select"
                                    options={getdefaultLookups?.result?.Lst_VerifiedProspect
                                        ?.map((option: any) => ({
                                            label: option?.value,
                                            value: option?.id
                                        }))}
                                    value={
                                        formik.values?.lst_VerifiedProspect?.id
                                            ? {
                                                value: formik.values?.lst_VerifiedProspect?.id,
                                                label: formik.values?.lst_VerifiedProspect?.value || '',
                                            }
                                            : null
                                    }
                                    isDisabled={isReadOnly}
                                    onChange={(selectedOption: any) => {
                                        formik.setFieldValue('lst_VerifiedProspect.id', selectedOption.value);
                                        formik.setFieldValue('lst_VerifiedProspect.value', selectedOption.label);
                                    }}
                                />
                            </div>
                            <>
                                <label className='input-label d-flex align-items-center gap-1'> {svgIcons.LockIcon}Lead Inquiry  </label>
                                <div className='col-md-12 br-gray p-2 bg-gray'>
                                    {formik?.values?.leadInquiry !== DefaultGuid && getLeadsByID && formik.values.currentStep >= 3 ?
                                        <Link to={`/leadsInquiry/editLeadInquiry/${formik?.values?.leadInquiry}`}>
                                            <span className='me-1'> {svgIcons?.LeadIconBlue}</span>
                                            {formik.values.leadInquiryRecNumber}
                                        </Link>
                                        : !isEdit && !isReadOnly && getExtLeadsById && formik.values.currentStep >= 3 ? <Link to={`/leadsInquiry/editLeadInquiry/${formik?.values?.leadInquiry}`}>
                                            <span className='me-1'> {svgIcons?.LeadIconBlue}</span>
                                            {formik.values.leadInquiryRecNumber}
                                        </Link> : ''}
                                </div>
                            </>
                        </div>
                    </div>
                    <div className='card'>
                        <div className='card-body card-css'>
                            <h5>
                                Marketing Information
                            </h5>
                            <div className='row'>

                                <div className="col-md-12">
                                    <label className="input-label">
                                        Prospect Date <span className="text-danger">*</span>
                                    </label>
                                    <div className="form-wrap icon-form ">
                                        <span className="form-icon">
                                            <i className="ti ti-calendar-check" />
                                        </span>
                                        <DatePicker
                                            className="form-control datetimepicker deals-details "
                                            // selected={selectedFreshAptmentDate}
                                            onChange={handleProspectDateChange}
                                            value={formik.values?.prospectDate ? dayjs(formik.values?.prospectDate, 'YYYY-MM-DD') : null}
                                            format="MMM-DD-YYYY"
                                        />
                                    </div>
                                    {formik.touched.prospectDate && formik.errors.prospectDate && (
                                        <div className="error">{formik.errors.prospectDate}</div>
                                    )}
                                </div>
                                {/* <div className="col-md-6">
                                    <label className="input-label">
                                        Time <span className="text-danger">*</span>
                                    </label>
                                    <TimePicker
                                        placeholder="Select Time"
                                        className="form-control datetimepicker-time"
                                        onChange={onChangeStart}
                                        defaultOpenValue={dayjs("12:00 AM", "h:mm A")}
                                        format="h:mm A"
                                        use12Hours
                                        disabled={isReadOnly}
                                    />
                                </div> */}
                                <div className="col-md-12">
                                    <label className="input-label">
                                    Consultation Date 
                                    </label>
                                    <div className="form-wrap icon-form ">
                                        <span className="form-icon">
                                            <i className="ti ti-calendar-check" />
                                        </span>
                                        <DatePicker
                                            className="form-control datetimepicker deals-details "
                                            // selected={selectedFreshAptmentDate}
                                            onChange={handleConsultationDateChange}
                                            value={formik.values?.consultationDate ? dayjs(formik.values?.consultationDate, 'YYYY-MM-DD') : null}
                                            format="MMM-DD-YYYY"
                                        />
                                    </div>
                                   
                                </div>
                                {/* <div className="col-md-6">
                                    <label className="input-label">
                                        Time
                                    </label>
                                    <TimePicker
                                        placeholder="Select Time"
                                        className="form-control datetimepicker-time"
                                        onChange={onChangeStart}
                                        defaultOpenValue={dayjs("12:00 AM", "h:mm A")}
                                        format="h:mm A"
                                        use12Hours
                                        disabled={isReadOnly}
                                    />
                                </div> */}
                                <div className="col-md-12">
                                    <label className='input-label'>Method of Inquiry <span className='text-danger'>*</span></label>
                                    <Select
                                        styles={customStyles}
                                        className="select"
                                        options={getdefaultLookups?.result?.Lst_MethodOfInquiry
                                            ?.map((option: any) => ({
                                                label: option?.value,
                                                value: option?.id
                                            }))}
                                        value={
                                            formik.values?.lst_MethodOfInquiry?.id
                                                ? {
                                                    value: formik.values?.lst_MethodOfInquiry?.id,
                                                    label: formik.values?.lst_MethodOfInquiry?.value || '',
                                                }
                                                : null
                                        }
                                        isDisabled={isReadOnly}
                                        onChange={(selectedOption: any) => {
                                            formik.setFieldValue('lst_MethodOfInquiry.id', selectedOption.value);
                                            formik.setFieldValue('lst_MethodOfInquiry.value', selectedOption.label);
                                        }}
                                    />
                                    {formik.touched.lst_MethodOfInquiry && formik.errors.lst_MethodOfInquiry && (
                                        <div className="error">{formik.errors.lst_MethodOfInquiry.value}</div>
                                    )}
                                </div>
                                <div className="col-md-12">
                                    <label className='input-label'>Lead Source code </label>
                                    <Select
                                        styles={customStyles}
                                        className="select"
                                        options={getdefaultLookups?.result?.Lst_LeadSourceCodes
                                            ?.map((option: any) => ({
                                                label: option?.value,
                                                value: option?.id
                                            }))}
                                        value={
                                            formik.values?.lst_LeadSourceCode
                                                ?.id
                                                ? {
                                                    value: formik.values?.lst_LeadSourceCode?.id,
                                                    label: formik.values?.lst_LeadSourceCode?.value || '',
                                                }
                                                : null
                                        }
                                        isDisabled={isReadOnly}
                                        onChange={(selectedOption: any) => {
                                            formik.setFieldValue('lst_LeadSourceCode.id', selectedOption.value);
                                            formik.setFieldValue('lst_LeadSourceCode.value', selectedOption.label);
                                        }}
                                    />
                                </div>
                                <div className="col-md-12">
                                    <label className='input-label'>Lead Source </label>
                                    <Select
                                        styles={customStyles}
                                        className="select"
                                        options={getdefaultLookups?.result?.Lst_LeadSourceType
                                            ?.map((option: any) => ({
                                                label: option?.value,
                                                value: option?.id
                                            }))}
                                        value={
                                            formik.values?.lst_LeadSourceType?.id
                                                ? {
                                                    value: formik.values?.lst_LeadSourceType?.id,
                                                    label: formik.values?.lst_LeadSourceType?.value || '',
                                                }
                                                : null
                                        }
                                        isDisabled={isReadOnly}
                                        onChange={(selectedOption: any) => {
                                            formik.setFieldValue('lst_LeadSourceType.id', selectedOption.value);
                                            formik.setFieldValue('lst_LeadSourceType.value', selectedOption.label);
                                        }}
                                    />
                                </div>
                                {/* <div className="col-md-12">
                                    <div className="form-wrap">
                                        <label className="input-label">Influencer</label>
                                        <Select
                                            isMulti={true}
                                            styles={customStyles}
                                            className="select multi-select"
                                            options={getdefaultLookups?.result?.Lst_Influencer?.map((option: any) => ({
                                                label: option?.value,
                                                value: option?.id
                                            })) || []}
                                            value={
                                                selectValues
                                            }
                                            isDisabled={isReadOnly}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    {formik.touched.lst_Influencer && formik.errors.lst_Influencer && (
                                        <div className="error">{formik.errors.lst_Influencer}</div>
                                    )}
                                </div> */}
                                <>
                                    <div className="col-md-12">
                                        <label className='input-label'>Lead Quality Code <span className='text-danger'>*</span></label>
                                        <Select
                                            styles={customStyles}
                                            className="select"
                                            options={getdefaultLookups?.result?.Lst_LeadQualityCode
                                                ?.map((option: any) => ({
                                                    label: option?.value,
                                                    value: option?.id
                                                }))}
                                            value={
                                                formik.values?.lst_LeadQualityCode?.id
                                                    ? {
                                                        value: formik.values?.lst_LeadQualityCode?.id,
                                                        label: formik.values?.lst_LeadQualityCode?.value || '',
                                                    }
                                                    : null
                                            }
                                            isDisabled={isReadOnly}
                                            onChange={(selectedOption: any) => {
                                                formik.setFieldValue('lst_LeadQualityCode.id', selectedOption.value);
                                                formik.setFieldValue('lst_LeadQualityCode.value', selectedOption.label);
                                            }}
                                        />
                                        {formik.touched.lst_LeadQualityCode && formik.errors.lst_LeadQualityCode && (
                                            <div className="error">{formik.errors.lst_LeadQualityCode.value}</div>
                                        )}
                                    </div>
                                    <div className="col-md-12">
                                        <TextField
                                            label="Lead Source Notes"
                                            type="text"
                                            {...formik.getFieldProps("leadSourceNotes")}
                                            disabled={isReadOnly}

                                        />
                                    </div>
                                    {/* <div className="col-md-12">
                                        <label>Web Form Entry</label>
                                        <InputMask mask="_"
                                            replacement={{ _: /\d/ }}
                                            className="form-control"
                                            {...formik.getFieldProps("webFormEntry")}
                                            disabled={isReadOnly}
                                        />
                                    </div> */}
                                    {/* <div className="col-md-12">
                                        <TextField
                                            label="Traffic Source"
                                            type="text"
                                            {...formik.getFieldProps("trafficSource")}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className="col-md-12">
                                        <TextField
                                            label="utmsource"
                                            type="text"
                                            {...formik.getFieldProps("utmsource")}
                                            disabled={isReadOnly}
                                        />
                                    </div> */}
                                </>
                            </div>
                        </div>
                    </div>

                    {/* <div className='card'>
                            <div className='card-body'>
                                {selectedItems.map((item) => {
                                    // Destructure id and title
                                    const { id, title } = item;

                                    // Check if the ID is in the set of multi-select labels
                                    const isMultiSelect = multiSelectLabels.has(id.toString());

                                    const titleToFieldName = (title: string) => {
                                        return 'Lst_' + title
                                            .replace(/ /g, '') // Remove spaces
                                    };

                                    const fieldName = titleToFieldName(title);
                                    const formikFieldName = titleToFormikFieldName(title); // Convert title to Formik field name
                                    const formikValue = formik.values[formikFieldName] || [];
                                    const mappedValue = formik.values[formikValue]?.map((option: any) => ({
                                        value: option.id.toString(),
                                        label: option.name,
                                    }));


                                    if (isMultiSelect) {
                                        // Directly use the title for rendering
                                        return (
                                            <div key={id} className='form-wrap'>
                                                <label className='input-label'>{title}</label>
                                                <Select
                                                    isMulti
                                                    name={title} // Use title directly
                                                    className="select multi-select"
                                                    options={optionsMapping[fieldName] || []}
                                                    value={mappedValue} // Ensure this matches the format
                                                    onChange={handleSelectChange(title)}
                                                />
                                            </div>
                                        );
                                    }

                                    return null;
                                })}

                                {matchedLabels.map(label => {
                                    const camelCaseLabel = label
                                        .split(' ')
                                        .map((word, index) => {
                                            if (word.length === 1 || word.toUpperCase() === word) {
                                                // Convert single letters or all-uppercase words to lowercase
                                                return word.toLowerCase();
                                            }
                                            return index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
                                        })
                                        .join('');

                                    const value = formik.values[camelCaseLabel as keyof typeof initialValues] as { id: number[]; name: string[] } || { id: [], name: [] };

                                    return (
                                        <div key={label} className='form-wrap'>
                                            <label className='input-label'>{label}</label>
                                            <Select
                                                isMulti
                                                name={camelCaseLabel}
                                                className="select multi-select"
                                                options={nestedOptionsMapping[label] || []}
                                                value={value.name.map((name: string, index: number) => ({
                                                    value: value.id[index].toString(),
                                                    label: name
                                                }))}
                                                onChange={handleNestedSelectChange(label)}
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                        </div> */}
                </div>
                <div className="col-md-4">
                    <div className="card">
                        <div className="card-body card-css">
                            <h5 className='mb-2'>Project Information</h5>
                            <div className="col-md-12">
                                <label className='input-label'>Subject <span className='text-danger'>*</span> </label>
                                <Select
                                    styles={customStyles}
                                    className="select"
                                    options={getdefaultLookups?.result?.Lst_Subject?.map((option: any) => ({
                                        label: option?.value,
                                        value: option?.id
                                    }))}
                                    value={
                                        formik.values?.lst_Subject?.id
                                            ? {
                                                value: formik.values?.lst_Subject?.id,
                                                label: formik.values?.lst_Subject?.value || '',
                                            }
                                            : null
                                    }
                                    isDisabled={isReadOnly}
                                    onChange={(selectedOption: any) => {
                                        formik.setFieldValue('lst_Subject.id', selectedOption.value);
                                        formik.setFieldValue('lst_Subject.value', selectedOption.label);
                                    }}
                                />
                                {formik.touched.lst_Subject && formik.errors.lst_Subject && (
                                    <div className="error">{formik.errors.lst_Subject.value}</div>
                                )}
                            </div>
                            <div className="col-md-12 mt-2">
                                <TextField
                                    label="Title"
                                    type="text"
                                    className="form-control"
                                    {...formik.getFieldProps('title')}
                                    disabled={isReadOnly} />
                            </div>
                            <div className="col-md-12 mt-2">
                                <label className="input-label">
                                    Need
                                </label>
                                <Select
                                    styles={customStyles}
                                    className="select"
                                    options={getdefaultLookups?.result?.Lst_Need?.map((option: any) => ({
                                        label: option?.value,
                                        value: option?.id
                                    }))}
                                    value={
                                        formik.values.lst_Need?.id
                                            ? {
                                                value: formik.values.lst_Need?.id,
                                                label: formik.values.lst_Need?.value || '',
                                            }
                                            : null
                                    }
                                    onChange={(selectedOption: any) => {
                                        formik.setFieldValue(`lst_Need.id`, selectedOption?.value || null);
                                        formik.setFieldValue(`lst_Need.value`, selectedOption?.label || null);
                                    }}
                                    isDisabled={isReadOnly}
                                />
                            </div>
                            <div className="col-md-12 mt-2">
                                <TextField
                                    label="Description"
                                    type="text"
                                    className="form-control"
                                    {...formik.getFieldProps('description')}
                                    disabled={isReadOnly} />
                            </div>
                            <div className="col-md-12">
                                <label className='input-label'>Project Type <span className='text-danger'>*</span></label>
                                <Select
                                    styles={customStyles}
                                    className="select"
                                    options={getdefaultLookups?.result?.Lst_ProjectType
                                        ?.map((option: any) => ({
                                            label: option?.value,
                                            value: option?.id
                                        }))}
                                    value={
                                        formik.values?.lst_ProjectType?.id
                                            ? {
                                                value: formik.values?.lst_ProjectType?.id,
                                                label: formik.values?.lst_ProjectType?.value || '',
                                            }
                                            : null
                                    }
                                    isDisabled={isReadOnly}
                                    onChange={(selectedOption: any) => {
                                        formik.setFieldValue('lst_ProjectType.id', selectedOption.value);
                                        formik.setFieldValue('lst_ProjectType.value', selectedOption.label);
                                    }}
                                />
                                {formik.touched.lst_ProjectType && formik.errors.lst_ProjectType && (
                                    <div className="error">{formik.errors.lst_ProjectType.value}</div>
                                )}
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="Project Details"
                                    type="text"
                                    {...formik.getFieldProps("projectDetails")}
                                    disabled={isReadOnly}

                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="Project Budget"
                                    type="number"
                                    {...formik.getFieldProps("projectBudget")}
                                    disabled={isReadOnly}
                                />
                            </div>
                            <div className="col-md-12">
                                <label className='input-label'>Project Status </label>
                                <Select
                                    styles={customStyles}
                                    className="select"
                                    options={getdefaultLookups?.result?.Lst_ProjectStatus?.map((option: any) => ({
                                        label: option?.value,
                                        value: option?.id
                                    }))}
                                    value={
                                        formik.values?.lst_ProjectStatus?.id
                                            ? {
                                                value: formik.values?.lst_ProjectStatus?.id,
                                                label: formik.values?.lst_ProjectStatus?.value || '',
                                            }
                                            : null
                                    }
                                    isDisabled={isReadOnly}
                                    onChange={(selectedOption: any) => {
                                        formik.setFieldValue('lst_ProjectStatus.id', selectedOption.value);
                                        formik.setFieldValue('lst_ProjectStatus.value', selectedOption.label);
                                    }}
                                />
                            </div>
                            <div className="col-md-12">
                                <label className='input-label'>Sub Status </label>
                                <Select
                                    styles={customStyles}
                                    className="select"
                                    options={getdefaultLookups?.result?.Lst_SubStatus?.map((option: any) => ({
                                        label: option?.value,
                                        value: option?.id
                                    }))}
                                    value={
                                        formik.values?.lst_SubStatus?.id
                                            ? {
                                                value: formik.values?.lst_SubStatus?.id,
                                                label: formik.values?.lst_SubStatus?.value || '',
                                            }
                                            : null
                                    }
                                    isDisabled={isReadOnly}
                                    onChange={(selectedOption: any) => {
                                        formik.setFieldValue('lst_SubStatus.id', selectedOption.value);
                                        formik.setFieldValue('lst_SubStatus.value', selectedOption.label);
                                    }}
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="Project Budget Notes"
                                    type="text"
                                    {...formik.getFieldProps("projectBudgetNotes")}
                                    disabled={isReadOnly}
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="Lead Intake Notes"
                                    type="text"
                                    {...formik.getFieldProps("leadIntakeNotes")}
                                    disabled={isReadOnly}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='card d-none'>
                        <div className='card-body card-css'>
                            <h5>The Airoom Companies -Product & Services</h5>
                            <div className="col-md-12">
                                <label className='input-label'>Airoom Product & Services</label>
                                <Select
                                    styles={customStyles}
                                    className="select"
                                    options={getdefaultLookups?.result?.Lst_AiroomProductServices
                                        ?.map((option: any) => ({
                                            label: option?.value,
                                            value: option?.id
                                        }))}
                                    value={
                                        formik.values?.lst_AIroomProductAndServices?.id
                                            ? {
                                                value: formik.values?.lst_AIroomProductAndServices?.id,
                                                label: formik.values?.lst_AIroomProductAndServices?.value || '',
                                            }
                                            : null
                                    }
                                    isDisabled={isReadOnly}
                                    onChange={(selectedOption: any) => {
                                        formik.setFieldValue('lst_AIroomProductAndServices.id', selectedOption.value);
                                        formik.setFieldValue('lst_AIroomProductAndServices.value', selectedOption.label);
                                    }}
                                />
                            </div>
                            {/* <div className="col-md-12">

                                    <DateField label="Airoom"
                                        selected={selectedAiroomDate}
                                        onChange={handleAiroomDateChange}
                                        disabled={isReadOnly}
                                    />
                                </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default GeneralTab